import { render } from "./HomeView.vue?vue&type=template&id=06ded2fa&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./HomeView.vue?vue&type=style&index=1&id=06ded2fa&scoped=true&lang=css"
import "./HomeView.vue?vue&type=style&index=2&id=06ded2fa&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/vue-smart-reco-vet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ded2fa"]])

export default __exports__